import { useCometState } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { getBrowserFaviconUrl, getCometBrowserInfo, isCometBrowser, } from '#pplx/frontend/comet/client/utils.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { useThrottledState } from '#pplx/frontend/common/hooks/useThrottledState.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useMemo } from 'react';
const STALE_TIMEOUT = 5_000;
const SIDECAR_PAGE_CHANGE_THROTTLE_MS = 3_000;
export const useTabsAttachments = (cometBrowser, enabled = true) => {
    const tabAttachmentsEnabled = enabled && isCometBrowser() && Boolean(getCometBrowserInfo()?.is_personal_search_enabled);
    const { sidecarSourceTab: { url: sidecarSourceTabUrl }, } = useCometState();
    const throttledSidecarSourceTabUrl = useThrottledState(sidecarSourceTabUrl, SIDECAR_PAGE_CHANGE_THROTTLE_MS);
    const queryKey = useMemo(() => {
        if (import.meta.env.VITE_IS_SIDECAR_BUILD || import.meta.env.VITE_IS_EMBEDDED_SIDECAR_BUILD) {
            return ['get_tabs_for_sidecar', throttledSidecarSourceTabUrl];
        }
        return ['get_tabs_for_ntp'];
    }, [throttledSidecarSourceTabUrl]);
    const { data: tabs = EMPTY_ARRAY } = useQuery({
        queryKey: queryKey,
        queryFn: async () => {
            const results = await cometBrowser.fetchOpenedTabs();
            return results.map((tab) => {
                const faviconUrl = getBrowserFaviconUrl(tab.url);
                return {
                    uuid: String(tab.tabId),
                    variant: 'tab',
                    label: tab.title,
                    url: tab.url,
                    icon: faviconUrl ? { type: 'image', url: faviconUrl } : undefined,
                };
            });
        },
        staleTime: STALE_TIMEOUT,
        enabled: tabAttachmentsEnabled,
    });
    return useMemo(() => ({
        tabs,
        tabAttachmentsEnabled,
    }), [tabAttachmentsEnabled, tabs]);
};
//# sourceMappingURL=useCometTabsAttachments.js.map